import { isNil } from 'lodash';
import React, { Component } from 'react';

import './SellAllShares.scss';

import {
  SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS,
  SELL_ALL_SHARES_DAILY_LIMIT_MODAL,
  SELL_ALL_SHARES_MODAL,
  SELL_ALL_SHARES_UNCOLLECTED_SHARES,
} from '../../../redux/modules/modals/modals.module';
import { UNIT } from '../../../settings/settings';
import Checkbox from '../../Shared/Checkbox/Checkbox';
import If from '../../Shared/If/If';
import {
  isAppSell,
  isCollegeAnything,
  isCollegeDistribute,
} from '../../../utils/transactions-util';
import words from '../../../utils/words';

class SellAllShares extends Component {
  constructor(props) {
    super(props);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { fund, openModal, updateSellFund } = this.props;

    const {
      agreementID,
      closeout,
      exceedsCloseoutDailyLimit,
      hasUncollectedShares,
      openToNewInvestors,
      sweep,
    } = fund;

    const shouldCloseoutPrev =
      isNil(prevProps.fund.closeout) || !prevProps.fund.closeout;

    if (shouldCloseoutPrev && closeout) {
      if (sweep && !hasUncollectedShares) {
        // if sweep and no uncollected shares, we don't show any pop-up. Update grossAmount in fund object.
        updateSellFund({
          agreementID,
          grossAmount: 100,
          grossUnit: UNIT.PERCENT,
        });
        return;
      }

      const modalName = exceedsCloseoutDailyLimit
        ? SELL_ALL_SHARES_DAILY_LIMIT_MODAL
        : hasUncollectedShares
        ? SELL_ALL_SHARES_UNCOLLECTED_SHARES
        : openToNewInvestors || isCollegeAnything() || isAppSell()
        ? SELL_ALL_SHARES_MODAL
        : SELL_ALL_SHARES_CLOSED_TO_NEW_INVESTORS;
      openModal(modalName, { fund });
    }
  }

  handleCheckboxClick() {
    const {
      fund: { agreementID, closeout, grossAmount },
      updateSellFund,
    } = this.props;
    const shouldCloseout = isNil(closeout) || !closeout;

    /**
     * this was originally defaulted to zero but design didn't feel adding '0' to the input was a natural behavior
     * it was requested that we empty the input hence 'undefined' when user changes mind and no longer wants to close
     * */
    updateSellFund({
      agreementID,
      closeout: shouldCloseout,
      grossAmount: shouldCloseout ? grossAmount : undefined,
      grossUnit: shouldCloseout ? UNIT.ALL_SHARES : UNIT.DOLLARS,
    });
  }

  render() {
    const {
      fund: {
        agreementID,
        closeout,
        grossAmountError,
        hasUncollectedShares,
        sweep,
      },
    } = this.props;
    return (
      <div
        className={`sell-all-shares-label ${
          grossAmountError ? 'sell-all-shares-error' : ''
        }`}
      >
        <Checkbox
          ariaLabel="sell all shares"
          checked={closeout}
          id={`sell-all-shares-checkbox-${agreementID}`}
          inline
          onClick={this.handleCheckboxClick}
        />

        <label
          htmlFor={`sell-all-shares-checkbox-${agreementID}`}
          className={`sell-all-shares-sub-label`}
        >
          {/* College Distribute - Distribute full account & close portfolio */}
          {/* Sell - Sell all [available] shares & close fund */}
          {isCollegeDistribute()
            ? 'Distribute full account'
            : isAppSell()
            ? 'Sell all investments'
            : 'Sell all ' +
              (hasUncollectedShares ? ' available ' : '') +
              'shares'}
          <If test={!sweep & !hasUncollectedShares}>
            {' & close '}
            {isAppSell() ? 'account' : words.fund}
          </If>
        </label>
      </div>
    );
  }
}

export default SellAllShares;
